import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalTransition, useModal } from 'react-simple-hook-modal';

import RequestForm from './RequestForm';
import './index.scss';

import { ProductInfoModel } from '../../../../models/request.model';
import { togglePopup, popupByName } from '../../../../store/ui';

export const RequestFormSpacesModal = () => {
    const dispatch = useDispatch();
    const { opened: isOpenModal, payload } = useSelector(popupByName('location_request_spaces'));
    const { isModalOpen, openModal, closeModal } = useModal();

    useEffect(() => {
        if (isOpenModal) {
            openModal();
        }
    }, [isOpenModal, openModal]);

    const handleClose = () => {
        closeModal();
        dispatch(togglePopup({ name: 'location_request_spaces', status: false }));
    };

    return (
        <Modal
            id="location__request-modal"
            isOpen={isModalOpen}
            transition={ModalTransition.NONE}
            onBackdropClick={handleClose}
        >
            <RequestForm
                close={handleClose}
                data={payload as unknown as ProductInfoModel[]}
                dataLayerEventName="product_finder_form_request_spaces"
            />
        </Modal>
    );
};
